import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { ESetUserDataActionType, TUserData } from './types';
import { IUserDataSchema } from '../../../repositories/journal/entities/user/UserDataSchema';

export const setUserData: (data: IUserDataSchema) => TUserData = actionGenerator<
  ESetUserDataActionType.Set,
  IUserDataSchema
>(ESetUserDataActionType.Set);
